export default "__VITE_ASSET__BhjmzHL___"